import React from "react";
import { CustomeDialog, DropDownButton } from "../../../shared";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import warning_icon from "../../../assets/images/Icons/icAlert.svg";

export const StockBulkUpdateTrigger = ({
  onConfirmBulkUpdateToggle,
  disabledOptions = true,
  loading = false,
}) => {
  const [toggleState, setToggle] = React.useState(null);
  const isStoreAdmin = window.location.pathname.includes("/store-admin");

  const onBulkItemClick = (value) => {
    setToggle(value || null);
  };

  const cancelBulkUpdateToggle = () => {
    setToggle(null);
  };

  const isEnableVisibility = toggleState?.value === 1;

  return (
    <>
      <DropDownButton
        onItemClick={onBulkItemClick}
        menuItems={[
          { label: "Enable Visibility", value: 1 },
          { label: "Disable Visibility", value: 0 },
        ]}
        disabled={disabledOptions}
      />

      <CustomeDialog
        title={
          <Stack
            direction="row"
            gap="10px"
            alignItems="center"
            p="24px"
            pb="8px"
          >
            <Box
              sx={{
                width: "30px",
                height: "30px",
                borderRadius: "35px",
                bgcolor: "#F044381F",
              }}
            >
              <img
                src={warning_icon}
                style={{ padding: "6px" }}
                alt="delete-future-cost"
              />
            </Box>
            <Typography fontWeight={500} variant="body1" fontSize="20px">
              {isEnableVisibility
                ? " Enable Visibility?"
                : "Disable Visibility?"}
            </Typography>
          </Stack>
        }
        open={toggleState !== null}
        divider={false}
        content={
          isStoreAdmin
            ? `The selected items will be ${isEnableVisibility ? "made visible" : "hidden"} in this store’s stocktake in the Recipe app.`
            : `This item will be ${isEnableVisibility ? "visible" : "hidden"} in the Stocktake module of the Recipe App for all stores selected. `
        }
        footer={{
          display: true,
          cancelButton: (
            <Button
              variant="outlined"
              color="gray2"
              onClick={cancelBulkUpdateToggle}
              size="small"
              disabled={loading}
            >
              Cancel
            </Button>
          ),
          confirmButton: (
            <Button
              variant="contained"
              color={isEnableVisibility ? "primary" : "error"}
              size="small"
              onClick={() =>
                onConfirmBulkUpdateToggle({
                  cancelBulkUpdateToggle,
                  type: toggleState.value,
                })
              }
              disabled={loading}
              sx={{ width: "80px" }}
            >
              {loading ? (
                <CircularProgress size={20} color="primary" />
              ) : isEnableVisibility ? (
                "Enable"
              ) : (
                "Disable"
              )}
            </Button>
          ),
          onConfirm: true,
          isDisabled: loading,
        }}
        sx={{
          pt: "16px",
          px: "24px",
          pb: "8px",
          width: { md: "500px", sm: "400px", xs: "90%" },
        }}
      />
    </>
  );
};
